import React from 'react';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Button from '../../components/buttons/Button';
import { Pie, Line } from 'react-chartjs-2';

const URL_LISTA = WS.relatorios.clientes;

//
class Relatorios extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      isLoading: true
    }
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: URL_LISTA,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.items
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  render() {
    const dataPie = {
        datasets: [{
            data: [230, 200],
            backgroundColor: [
                  '#ff6384',
                  '#36a2eb'
              ]
        }],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [
            'Plano 1',
            'Plano 2'
        ]
    };

    let wrapper = this.state.isLoading ? <LoadingPage /> : <Pie data={dataPie} />;

    const dti = this.props.detalhe ? this.props.detalhe.dti : null;
    const dtf = this.props.detalhe ? this.props.detalhe.dtf : null;
    const { dataInicio, dataFim, procurar } = this.state.strings;
    const dataField = this.props.type === 'planos_data' ?
    (<div className=''>
      <div className="pure-u-9-24">
      <DateRangePickerWrapper
         dti={dti}
         dtf={dtf}
         titleDateInicio={dataInicio}
         titleDateFim={dataFim} />

      </div>
      <div className="pure-u-9-24">
        <div className='box-button-search-date'><Button type="submit" text={procurar} classes="bt-save bt-blue" /></div>
      </div>
      <br /><br />
    </div>
    ) : null;

    return (
      <div>
        <div className='title-relatorio'>{this.state.lista.length} {this.props.title}</div>
        {dataField}
        {wrapper}
      </div>
    );
  }
}

export default Relatorios;



// WEBPACK FOOTER //
// ./src/classes/relatorios/RelatoriosPlanos.js